// specific to SA
import Component from '../../UM-Base/components/Component';

export default class BookingReviews extends Component {
	load() {
		(function(d, sc, u) {
			var s = d.createElement(sc), p = d.getElementsByTagName(sc)[0];
			s.async = true;
			s.src = u + '?v=' + (+new Date());
			p.parentNode.insertBefore(s,p);
		})(document, 'script', '//aff.bstatic.com/static/affiliate_base/js/flexiproduct.js');
		super.load();
	}
}
